import React, { useState, useEffect, useCallback, useMemo } from 'react';
import useHandleAddProduct from '../../../utils/handleAddProduct';
import { BASKET_CACHE_KEY } from '../../../utils/handleLocalStorage';
import CustomButton from '../button';
import SelectCurrency from '../selectCurrency';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../store/user';
import ShowCurrencies from '../../../utils/showCurrencies';
import services from '../../../services';
import { IoMdTime } from 'react-icons/io';
import Skeleton from 'react-loading-skeleton';
import TopCard from './TopCard';
import CategoryTabs from './CategoryTabs';
import InfoIcon from './InfoIcon';
import BottomCard from './BottomCard';

function QurbanWidgetContent2(props) {
  const {
    topList = [],
    bottomList = [],
    cardTitle = '',
    cardSubTitle = '',
    topCardTitle = '',
    topCardImageBlue = '',
    topCardProductTitle = '',
    topCardProduct = [],
    topCardTitle2 = '',
    topCardImageBlue2 = '',
    topCardProduct2Title = '',
    topCardProduct2 = [],
    limitedTitle = 'Limited Stock Available!',
    limitedText = '',
    limitedImage = '',
    limitedProduct = [],
    categories = [],
    buttonLable = 'Donate Now',
    showProductsOneRow = false,
  } = props;

  const [addProduct, editProduct, removeProduct] = useHandleAddProduct();
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const navigate = useNavigate();
  const [totalSaledLimitedProduct, setTotalSaledLimitedProduct] = useState(0);
  // --- basket + quantities state ---
  const [basket, setBasket] = useState(() => {
    const raw = localStorage.getItem(BASKET_CACHE_KEY);
    return raw ? JSON.parse(raw) : { products: [], grandTotal: 0, adminCost: 0 };
  });
  // const [basket, setBasket] = useState({
  //   products: [],
  //   grandTotal: 0,
  //   adminCost: 0,
  // });
  const [quantities, setQuantities] = useState({});
  const [hydrated, setHydrated] = useState(false);

  // state for tab-specific total
  // const [totalAmountTab, setTotalAmountTab] = useState(0);

  // --- sync from storage ---
  const hydrateFromStorage = useCallback(() => {
    const raw = localStorage.getItem(BASKET_CACHE_KEY);
    const saved = raw ? JSON.parse(raw) : { products: [], grandTotal: 0, adminCost: 0 };
    setBasket(saved);

    // rebuild quantities
    const initQ = {};
    [...topList, ...bottomList, ...topCardProduct, ...topCardProduct2, ...limitedProduct].forEach(item => {
      initQ[item.creator] = { quantity: 0, selected: false };
    });
    (saved.products || []).forEach(({ product, quantity }) => {
      if (product && initQ[product.creator]) {
        initQ[product.creator] = { quantity, selected: quantity > 0 };
      }
    });
    setQuantities(initQ);
    setHydrated(true);
  }, [topList, bottomList, topCardProduct, topCardProduct2, limitedProduct]);

  useEffect(() => {
    hydrateFromStorage();
  }, [hydrateFromStorage]);

  useEffect(() => {
    window.addEventListener('localStorageUpdated', hydrateFromStorage);
    return () => {
      window.removeEventListener('localStorageUpdated', hydrateFromStorage);
    };
  }, [hydrateFromStorage]);

  // --- derive Top-Card state so it never “flickers” ---
  const topCardState = useMemo(() => {
    return topCardProduct.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        quantity: found?.quantity || 0,
      };
    });
  }, [topCardProduct, basket.products]);

  const secondCardState = useMemo(() => {
    return topCardProduct2.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        quantity: found?.quantity || 0,
      };
    });
  }, [topCardProduct2, basket.products]);

  // --- derive Limited-Product state likewise ---
  const limitedState = useMemo(() => {
    return limitedProduct.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        quantity: found?.quantity || 0,
      };
    });
  }, [limitedProduct, basket.products]);

  // --- derive topListState & columns synchronously ---
  const topListState = useMemo(() => {
    return topList.map(item => {
      const found = basket.products?.find(p => p.product?.creator === item.creator);
      return {
        ...item,
        isAdded: !!found,
        quantity: found?.quantity || 0,
      };
    });
  }, [topList, basket.products]);

  const columns = useMemo(() => {
    const half = Math.ceil(topListState.length / 2);
    return [topListState.slice(0, half), topListState.slice(half)];
  }, [topListState]);

  // --- total amount minus adminCost ---
  // const totalAmount = useMemo(() => {
  //   const creators = new Set([
  //     ...topCardProduct,
  //     ...limitedProduct,
  //     ...topList,
  //     ...bottomList
  //   ].map(item => item.creator));
  //   const tabTotal = (basket.products || []).reduce((sum, { product, quantity }) => {
  //     if (product && creators.has(product.creator)) {
  //       const price = product[selectedCurrencyStore.toLowerCase()] || product.usd || 0;
  //       return sum + quantity * price;
  //     }
  //     return sum;
  //   }, 0);

  //   setTotalAmountTab(tabTotal);
  //   return (basket.grandTotal || 0) - (basket.adminCost || 0);
  // }, [basket]);

  const mappedCategories = categories.map(cat => ({
    key: cat.key,
    label: cat.label,
    Icon: cat.key === 'sheep' ? 'SheepIcon' : cat.key === 'cows' ? 'CowIcon' : null,
  }));

  const [selected, setSelected] = useState(mappedCategories[0]?.key)


  const totalAmount2 = useMemo(() => {
    const creators = new Set([...topCardProduct, ...topCardProduct2, ...limitedProduct, ...topList, ...bottomList].map(item => item.creator));
    const tabTotal = (basket.products || []).reduce((sum, { product, quantity }) => {
      if (product && creators.has(product.creator)) {
        // console.log("creatords if", product)
        const price = product[selectedCurrencyStore.toUpperCase()] || product.USD || 0;
        return sum + quantity * price;
      }
      return sum;
    }, 0);
    // console.log("creatords", creators, tabTotal,basket)
    return tabTotal;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [basket]);
  }, [basket.products, selectedCurrencyStore, topCardProduct, topCardProduct2, limitedProduct, topList, bottomList]);

  // --- limited stock count ---
  useEffect(() => {
    if (limitedProduct.length) {
      const id = limitedProduct[0].creator;
      services
        .getLatestOrdersV3({
          products: [{ campaign: 'palestine', id, start_date: '2025-03-01', end_date: '2025-08-21' }],
          currency: selectedCurrencyStore,
        })
        .then(res => setTotalSaledLimitedProduct(res.data[0]?.total_count || 0))
        .catch(console.error);
    }
  }, [limitedProduct, selectedCurrencyStore]);

  // --- add / reduce ---
  const handleAddQty = useCallback(
    prd => {
      addProduct({
        product: { ...prd, quantity: 1 },
        currency: selectedCurrencyStore,
        justAddToLocalStorage: true,
      });
      hydrateFromStorage();
    },
    [addProduct, selectedCurrencyStore, hydrateFromStorage],
  );

  const handleReduceQty = useCallback(
    prd => {
      const currentQty = quantities[prd.creator]?.quantity || 0;
      if (currentQty < 2) {
        removeProduct(prd);
      } else {
        editProduct({ product: { ...prd, quantity: -1 }, currency: selectedCurrencyStore, justAddToLocalStorage: true });
      }
      hydrateFromStorage();
      // if (currentQty <= 0) return;
    },
    [editProduct, selectedCurrencyStore, quantities, hydrateFromStorage, removeProduct],
  );

  // --- UI helpers ---
  const currAmmount = (code, amt) => `${getSymbolFromCurrency(code.toLowerCase())}${amt}`;
  const handleDonateNow = () => navigate('/checkout');
  const [openDescriptionId, setOpenDescriptionId] = useState(null);
  // const [focusedCardId, setFocusedCardId] = useState(null);
  // UI handlers
  const toggleDescription = id => setOpenDescriptionId(openDescriptionId === id ? null : id);
  // const handleSelectCard = id => setFocusedCardId(id);
  const handleBlur = e => {
    // if (!e.currentTarget.contains(e.relatedTarget)) setFocusedCardId(null);
  };

  return (
    <div className="bg-[#E9F7FF] flex flex-col items-center justify-center md:p-4-" tabIndex={-1}>
      <div className="bg-transparent shadow-lg- p-2 md:p-4 w-full md:w-[648px]- min-h-fit max-w-full mx-auto ">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-primaryDark mb-4">{cardTitle}</h2>
          <div dangerouslySetInnerHTML={{ __html: cardSubTitle }} />
          {/* console.log("on content", topCardState, limitedState) */}
          {topCardState?.length > 0
            ? topCardState.map(item => {
                const quantityValue = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;

                return (
                  <TopCard
                    key={item.id}
                    item={item}
                    quantity={quantityValue}
                    price={price}
                    showProductsOneRow={showProductsOneRow}
                    currencyStore={selectedCurrencyStore}
                    productTitle={topCardProductTitle}
                    badgeType={item.badgeType}
                    currAmount={currAmmount}
                    onAdd={() => handleAddQty(item)}
                    onRemove={() => handleReduceQty(item)}
                    onBlur={handleBlur}
                  />
                );
              })
            : null}
          {secondCardState?.length > 0
            ? secondCardState.map(item => {
                const quantityValue = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;

                return (
                  <TopCard
                    key={item.id}
                    item={item}
                    quantity={quantityValue}
                    price={price}
                    showProductsOneRow={showProductsOneRow}
                    currencyStore={selectedCurrencyStore}
                    productTitle={topCardProduct2Title}
                    badgeType={'lowCost'}
                    currAmount={currAmmount}
                    onAdd={() => handleAddQty(item)}
                    onRemove={() => handleReduceQty(item)}
                    onBlur={handleBlur}
                  />
                );
              })
            : null}
          {limitedState?.length > 0
            ? limitedState.map(item => {
                const quantityValue = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;

                return (
                  <TopCard
                    key={item.id}
                    item={item}
                    quantity={quantityValue}
                    price={price}
                    showProductsOneRow={showProductsOneRow}
                    currencyStore={selectedCurrencyStore}
                    productTitle={limitedText}
                    badgeType={'limited'}
                    limitedProductCount={totalSaledLimitedProduct}
                    limitedProductMaxCount={4000}
                    currAmount={currAmmount}
                    onAdd={() => handleAddQty(item)}
                    onRemove={() => handleReduceQty(item)}
                    onBlur={handleBlur}
                  />
                );
              })
            : null}
          <div>
            <CategoryTabs categories={mappedCategories} selected={selected} onSelect={setSelected} />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-4 mt-5">
            {/* {console.log("top lists=", topListState)} */}
            {topListState.length === 0 ? (
              <div className="flex justify-center items-center w-[300px] h-[200px]">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#00A3DA]"></div>
              </div>
            ) : (
              columns.map((column, colIndex) => (
                <div key={colIndex} className={`${showProductsOneRow ? 'col-span-2 md:col-span-1' : ''} space-y-3 bg-white`}>
                  {column.map(item => {
                    const quantityValue = quantities[item.creator]?.quantity || 0;
                    const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;

                    return (
                      <div
                        key={item.id}
                        className={`border ${openDescriptionId === item.id ? '' : ''} rounded-lg flex items-center p-1 shadow-md`}
                        onClick={e => {
                          e.stopPropagation();
                          // handleSelectCard(item.id);
                        }}
                        tabIndex={0}
                        onBlur={handleBlur}
                      >
                        <div className="flex flex-col items-center w-full">
                          <div className={`flex ${showProductsOneRow ? '' : 'flex-col '} items-center w-full`}>
                            <div className="flex items-center w-full justify-between">
                              <p
                                className="
                                 flex-1
                                 font-bold text-[15px] leading-[15px]
                                 text-left decoration-[1px] text-[#00A3DA]
                                 whitespace-normal
                               "
                              >
                                {item.name}
                              </p>

                              <InfoIcon className="w-5 h-5 flex-shrink-0 ml-2" />
                            </div>
                            <div className="flex items-center w-full sm:ml-1 mt-1">
                              <img
                                src={item.image_link}
                                alt={item.name}
                                className={`${showProductsOneRow ? '' : 'hidden-'} md:block w-16 h-16 object-cover mr-2 rounded shadow-md`}
                              />
                              <div className="flex flex-col items-start w-full justify-center">
                                {/* price tag omitted for brevity */}
                                <p className={` font-brandingBold text-[17px] text-[#00A3DA] w-full  bg-[#E9F7FF] py-1 px-1 w-fit mr-1 rounded-lg`}>
                                  {ShowCurrencies(selectedCurrencyStore, Number(price))}
                                </p>

                                <div className="flex w-full mt-1 bg-[#E9F7FF] justify-between p-1 rounded-lg">
                                  {/* Minus button */}
                                  <button
                                    onClick={e => {
                                      e.stopPropagation();
                                      handleReduceQty(item, colIndex);
                                    }}
                                    className="w-7 h-7 bg-[#00A3DA] rounded-lg flex items-center justify-center text-white text-[24px] font-bold"
                                  >
                                    –
                                  </button>

                                  {/* Quantity display */}
                                  <span className="w-8 text-center text-base text-[#00A3DA] font-[17px]">{quantityValue}</span>

                                  {/* Plus button */}
                                  <button
                                    onClick={e => {
                                      e.stopPropagation();
                                      handleAddQty(item, colIndex);
                                    }}
                                    className="w-7 h-7 bg-pink rounded-lg flex items-center justify-center text-white text-[24px] font-bold"
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="flex w-full items-center justify-end ml-auto mt-1">
                              <div className="flex items-center w-full">
                                <button
                                  className={`bg-pink text-white flex justify-center items-center rounded-lg px-2 h-7 w-full`}
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleAddQty(item, colIndex);
                                  }}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                          {openDescriptionId === item.id && (
                            <div className="text-xs p-2 text-[#253B7E] font-branding">{item.short_description || item.description}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))
            )}
          </div>
          {bottomList?.length > 0
            ? bottomList.map(item => {
                const quantityValue = quantities[item.creator]?.quantity || 0;
                const price = item[selectedCurrencyStore.toLowerCase()] || item.usd || 0;

                return (
                  <BottomCard
                    key={item.id}
                    item={item}
                    quantity={quantityValue}
                    price={price}
                    showProductsOneRow={showProductsOneRow}
                    currencyStore={selectedCurrencyStore}
                    currAmount={currAmmount}
                    onAdd={() => handleAddQty(item)}
                    onRemove={() => handleReduceQty(item)}
                    onBlur={handleBlur}
                  />
                );
              })
            : null}

          <div className="bg-[#CAECFF] rounded-lg p-4 flex items-center justify-between">
            {/* left: currency dropdown */}
            <div className="basis-1/3 max-w-[33%]">
              <SelectCurrency onChangeCurrency={e => {}} classNamePrefix="home_select" />
            </div>

            {/* right: total label + amount */}
            <div className="flex items-baseline">
              <span className="text-[#00A3DA] font-semibold font-Arial  text-[25px] mr-2">Total:</span>
              <span className="text-pink-500 font-bold text-2xl text-pink">
                {currAmmount(
                  selectedCurrencyStore,
                  Number(totalAmount2).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                  }),
                )}{' '}
                {selectedCurrencyStore.toUpperCase()}
              </span>
            </div>
          </div>

          <div className="flex flex-wrap">
            <div className=" flex w-full justify-center items-center mt-4">
              <CustomButton
                title={buttonLable}
                onClick={handleDonateNow}
                className="bg-pink w-[90%] text-white rounded-full hover:bg-primaryDark text-xs w-[30px]- h-[20px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QurbanWidgetContent2;
